var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"vmv"}},[_c('div',{staticClass:"aboutVMV"},[_c('parallax',{attrs:{"speedFactor":0.3}},[_c('img',{attrs:{"src":_vm.img}})]),_c('div',{staticClass:"aboutCards"},[_c('AboutCard')],1),_c('div',{staticClass:"red"})],1)])}
var staticRenderFns = []

export { render, staticRenderFns }